import React, { useState, useEffect } from 'react';
import { projectsAPI } from '../../../services/api';
import ProjectTable from './ProjectTable';
import './project.css';

const CreateProject = () => {
  const [projects, setProjects] = useState([]);

//   const [name, setName] = useState('');
//   const [description, setDescription] = useState('');
//   const [status, setStatus] = useState('ACTIVE');
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');

  const fetchProjects = async () => {
    const res = await projectsAPI.getAll();
    setProjects(res.data);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

//   const handleCreate = async () => {
//     await projectsAPI.create({ name, description, status, startDate, endDate });
//     fetchProjects();
  
//   };

  const handleDelete = async (id) => {
    await projectsAPI.delete(id);
    fetchProjects();
  };

  const handleUpdate = async (id, updatedData) => {
  try {
    await projectsAPI.update(id, updatedData);

    // 🔥 refresh project list
    await fetchProjects();

    alert('Project updated successfully ✅');
  } catch (error) {
    console.error(error);
    alert('Failed to update project ❌');
  }
};

  return (
    <div className="project-wrapper">

      

      {/* <ProjectForm
        name={name}
        setName={setName}
        description={description}
        setDescription={setDescription}
        status={status}
        setStatus={setStatus}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        handleCreate={handleCreate}
      /> */}

      <ProjectTable
        projects={projects}
        handleDelete={handleDelete}
        handleUpdate={handleUpdate} 
         handleCreate={async (data) => {        
    await projectsAPI.create(data);
    fetchProjects();
    alert('Project created successfully ✅');
  }}
      />
    </div>
  );
};

export default CreateProject;